import Workspace from "../powerBi/Workspace";

export default class Usuario{
  constructor(obj) {
    obj = obj || {};
    this.email = obj.email;
    this.senha = obj.senha;
    this.clienteId = obj.clienteId;
    this.token = obj.token;
    this.workspaces =  obj.workspaces && obj.workspaces.map(w => new Workspace(w));
  }
}

